import { render, staticRenderFns } from "./DetailsContent.vue?vue&type=template&id=781c1d53"
import script from "./DetailsContent.vue?vue&type=script&lang=ts"
export * from "./DetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports